export default __webpack_public_path__ + "static/media/react.a060cbe8.svg";